import { Box } from '@mui/material';
import { Field } from 'formik';
import { useMemo, useState } from 'react';

import { FormPart } from '@modules/shared/components/FormPart';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { statesList } from '@shared/constants/statesList';
import { PhoneInputField } from '@shared/fields/PhoneInputField';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { TextInputField } from '@shared/fields/TextInputField';
import { ZipCodeInputField } from '@shared/fields/ZipCodeInputField';
import { FedexLabelFormWrapper } from '@styles/ContactManager/DealStyles';
import { DealsButton } from '@styles/StyledButtons';
import { IContactData } from './interfaces';

interface IFedexModalFormProps {
  contactData: IContactData;
  serviceTypes: { shipmentServiceTypes: string[] };
  onChange: (val: boolean) => void;
  loading: boolean;
  setFieldValue: <T>(field: string, value: T, shouldValidate?: boolean) => void;
}

export const FedexLabelForm = ({ serviceTypes, onChange, loading, setFieldValue }: IFedexModalFormProps) => {
  const [overrideFlag, setOverrideFlag] = useState(false);

  const shipmentServiceTypes = useMemo(
    () =>
      (serviceTypes?.shipmentServiceTypes ?? []).map((type) => ({
        label: type,
        value: type,
      })),
    [serviceTypes?.shipmentServiceTypes],
  );

  const config = [
    {
      name: 'name',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'companyName',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'phoneNumber',
      width: '25%',
      component: PhoneInputField,
    },
    {
      name: 'streetName',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'streetName2',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'city',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'state',
      width: '25%',
      options: statesList,
      component: SelectAutocompleteField,
      onChange: (value: string) => {
        setFieldValue('state', value);
        setFieldValue('postalCode', '');
      },
    },
    {
      name: 'postalCode',
      width: '25%',
      component: ZipCodeInputField,
    },
    {
      name: 'countryCode',
      width: '25%',
      component: TextInputField,
    },
    {
      name: 'fedexServiceType',
      width: '25%',
      options: shipmentServiceTypes,
      component: SelectAutocompleteField,
    },
  ];

  return (
    <>
      <FedexLabelFormWrapper>
        <Box style={{ width: '80%', display: 'flex' }} className="top-check-feilds">
          <Box style={{ width: '20%', marginRight: '10px' }}>
            <Field type="checkbox" name="returnLabel" />

            <span>Return Label</span>
          </Box>
          <Box style={{ width: '30%', marginRight: '10px' }}>
            <Field
              type="checkbox"
              name="override"
              value={overrideFlag}
              checked={overrideFlag}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onChange={(e: any) => {
                onChange(e.target.checked);
                setOverrideFlag(e.target.checked);
              }}
            />

            <span>Override Contact & Address Details</span>
          </Box>
        </Box>

        <Box>
          <DealsButton type="submit" size="medium" loading={loading}>
            Generate
          </DealsButton>
        </Box>
      </FedexLabelFormWrapper>

      {overrideFlag ? (
        <FedexLabelFormWrapper>
          <FormPart config={config as IFormFieldConfig<typeof config>[]} />
        </FedexLabelFormWrapper>
      ) : null}
    </>
  );
};
